import { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default function ShopTeaserSection() {
  const sectionRef = useRef<HTMLElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.fromTo(
        contentRef.current,
        { opacity: 0, y: 30 },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          scrollTrigger: {
            trigger: sectionRef.current,
            start: 'top 70%',
          },
        }
      );
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
    <section
      ref={sectionRef}
      className="relative overflow-hidden min-h-[420px] lg:min-h-[600px] bg-background-50"
    >
      {/* Content */}
      <div className="relative z-10 flex items-center justify-center min-h-[420px] lg:min-h-[600px] px-4 md:px-8 lg:px-12">
        <div ref={contentRef} className="text-center max-w-2xl">
          {/* Subtle accent line */}
          <div className="flex items-center justify-center gap-3 mb-6">
            <span className="block w-12 h-px bg-accent-500/50" />
            <span className="block w-1 h-1 rounded-full bg-accent-500" />
            <span className="block w-12 h-px bg-accent-500/50" />
          </div>

          <p className="text-accent-500 text-xs font-body tracking-[0.25em] uppercase mb-5">
            The tools
          </p>

          <h2 className="font-heading text-2xl md:text-4xl lg:text-5xl leading-[1.2] text-foreground-950 mb-6">
            Take the healing into your own hands.
          </h2>

          <p className="font-body text-sm md:text-base text-foreground-700 leading-relaxed mb-8 max-w-lg mx-auto">
            A structured healing journal and 52 daily prompt cards, designed by a
            clinical psychologist. Beautiful enough to display. Deep enough to
            transform.
          </p>

          <a
            href="/shop"
            className="inline-flex items-center justify-center px-7 py-3.5 bg-primary-500 text-white text-sm font-body font-medium rounded-full hover:bg-primary-600 transition-colors duration-300 whitespace-nowrap"
          >
            Shop The Collection
          </a>
        </div>
      </div>
    </section>
  );
}